export default "__VITE_ASSET__7Zw2SkCW__"